import { Home } from '@/site/autoloader'

export default [
	{
		path: '/',
		name: 'home',
		component: Home,
	},
]
